import React, { useState, useEffect } from 'react';

const RestaurantMenus = () => {
    const [restaurants, setRestaurants] = useState([]);
    const [selectedRestaurant, setSelectedRestaurant] = useState('');
    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const apiUrl = import.meta.env.VITE_API_URL;
    const menuEndpoint = import.meta.env.VITE_get_all_menus;
    const menuItemsEndpoint = import.meta.env.VITE_get_menu_items;

    useEffect(() => {
        fetchRestaurants();
    }, []);

    useEffect(() => {
        if (selectedRestaurant) {
            fetchMenuItems(selectedRestaurant);
        }
    }, [selectedRestaurant]);

    const fetchRestaurants = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${apiUrl}${menuEndpoint}`);
            if (response.ok) {
                const data = await response.json();
                setRestaurants(data);
            } else {
                console.error('Failed to fetch restaurants');
            }
        } catch (error) {
            console.error('Error fetching restaurants:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchMenuItems = async (menuId) => {
        try {
            setLoading(true);
            const response = await fetch(`${apiUrl}${menuItemsEndpoint}?menuId=${menuId}`);
            if (response.ok) {
                const data = await response.json();
                setMenuItems(data || []);
            } else {
                console.error('Failed to fetch menu items');
                setMenuItems([]);
            }
        } catch (error) {
            console.error('Error fetching menu items:', error);
            setMenuItems([]);
        } finally {
            setLoading(false);
        }
    };

    const handleRestaurantChange = (event) => {
        setSelectedRestaurant(event.target.value);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const downloadMenuItemsAsCSV = () => {
        if (!selectedRestaurant || menuItems.length === 0) {
            alert('يرجى اختيار مطعم أولاً لعرض الأصناف');
            return;
        }

        const selectedRestaurantData = restaurants.find(r => r.menuID.toString() === selectedRestaurant);
        const restaurantName = selectedRestaurantData?.menuName || 'مطعم';

        // Create CSV content with Arabic headers
        const csvHeaders = ['اسم الصنف', 'سعر الصنف'];
        const csvRows = menuItems.map(item => [
            item.itemName || '',
            item.itemPrice?.toString() || '0'
        ]);

        // Combine headers and rows
        const csvContent = [csvHeaders, ...csvRows]
            .map(row => row.map(cell => `"${cell}"`).join(','))
            .join('\n');

        // Create BOM for UTF-8 encoding
        const BOM = '\uFEFF';
        const csvWithBOM = BOM + csvContent;

        // Create and download the file
        const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `${restaurantName}_قائمة_الأصناف.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        URL.revokeObjectURL(url);
    };

    const filteredRestaurants = restaurants.filter(restaurant =>
        restaurant.menuName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    /*const selectedRestaurantData = restaurants.find(r => r.menuId.toString() === selectedRestaurant);*/

    return (
        <section className="main_content">
            <div className="container">
                <h1 className="page-title">قوائم المطاعم</h1>
                {/* Search and Filter Section */}
                <div className="action-buttons">
                    <div
                        className="download-icon"
                        onClick={downloadMenuItemsAsCSV}
                        title="تحميل قائمة الأصناف كملف CSV"
                    >
                        <span className="download-arrow">↓</span>
                    </div>
                    <select
                        className="form-select"
                        value={selectedRestaurant}
                        onChange={handleRestaurantChange}>
                        <option value="">اختر مطعم</option>
                        {filteredRestaurants.map((restaurant) => (
                            <option key={restaurant.menuID} value={restaurant.menuID}>
                                {restaurant.menuName}
                            </option>
                        ))}
                    </select>
                </div>
                {/* Menu Items Table */}
                {selectedRestaurant && (

                    <div >
                        <table className="table">
                            <thead>
                                <tr>
                                    <th >اسم الصنف</th>
                                    <th >سعر الصنف</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="2" className="loading-cell">جاري التحميل...</td>
                                    </tr>
                                ) : menuItems.length > 0 ? (
                                    menuItems.map((item, index) => (
                                        <tr key={item.itemId}>
                                            <td>{item.itemName}</td>
                                            <td>{item.itemPrice.toFixed(2)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="no-items-cell">لا توجد أصناف</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                )}

                {!selectedRestaurant && (
                    <div className="no-selection-message">
                        <p>يرجى اختيار مطعم لعرض قائمة الأصناف</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default RestaurantMenus;
